import {DI_TOKENS} from '@/di/di.tokens';

import {injected} from 'brandi';

import {HttpError} from '@specials/project-user';

import {CacheService} from '@/services/CacheService/CacheService';
import {LoggerService} from '@/services/LoggerService/LoggerService';
import {IProjectApi} from '@/services/ProjectApi/types';
import {UserStore} from '@/stores/UserStores/UserStore';

export class OnboardingFinishUseCase {
  constructor(
    private readonly projectApi: IProjectApi,
    private readonly userStore: UserStore,
    private readonly loggerService: LoggerService,
    private readonly cacheService: CacheService,
  ) {}

  public finishOnboarding = async (): Promise<void> => {
    if (this.userStore.getUserIsOnboardingFinished()) {
      return;
    }

    // сохраняем флаг просмотра модалки онбординга
    if (!this.cacheService.getIsOnboardingModalShown()) {
      this.cacheService.saveOnboardingModalShown();
    }

    await this.sendFinishOnboarding();
  };

  public sendFinishOnboarding = async (): Promise<void> => {
    try {
      await this.projectApi.finishOnboarding();
      this.userStore.setOnboardingFinishedSuccess();
      // в случае успешного сохранения результата прохождения онбординга
      // очищаем флаг просмотра модалки из кэша
      this.cacheService.deleteIsOnboardingModalShown();
    } catch (error: unknown) {
      this.loggerService.logHttpError(error as HttpError);
    }
  };
}

injected(
  OnboardingFinishUseCase,
  DI_TOKENS.projectApi,
  DI_TOKENS.userStore,
  DI_TOKENS.loggerService,
  DI_TOKENS.cacheService,
);
